import { Directive, HostListener, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Directive({
    selector: '[appResponsiveCheck]',
    exportAs: 'appResponsiveCheck',
    standalone: false
})
export class ResponsiveCheckDirective implements OnInit {

    responsiveCheck     = false;
    responsiveCheckNew  = '';
    isTypeDevice: string;
    @HostListener('window:resize') onResize() {
        this.checkSize();
    }
    constructor(private deviceService: DeviceDetectorService) {
        const isBrowser = this.deviceService.getDeviceInfo().browser;
        const isOs = this.deviceService.getDeviceInfo().os;
        // const isDeskTop = this.deviceService.isMobile();
        // const isTablet = this.deviceService.isTablet();
        if (this.deviceService.isMobile()) {
            this.isTypeDevice = 'mobile';
        } else if (this.deviceService.isTablet()) {
                this.isTypeDevice = 'tablet';
        } else {
            this.isTypeDevice = 'desktop';
        }
        document.getElementById('insure').classList.add(isBrowser, isOs, this.isTypeDevice);
    }

    ngOnInit() {
        this.checkSize();
    }

    checkSize() {
        let windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
        if (windowWidth >= 960) {
            this.responsiveCheck = true;
        } else {
            this.responsiveCheck = false;
        }
        //revised
        if (windowWidth >= 960) {
            this.responsiveCheckNew = 'desktop';
        } else if (windowWidth <= 768){
            this.responsiveCheckNew = 'tablet';
        } else if (windowWidth <= 475){
            this.responsiveCheckNew = 'mobile';
        }    
    }
}